import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import '../index.css';
import {
  checkEmailDuplication,
  sendResetEmail,
} from '../modules/NetworkFunction';

function PwSearch({ history }) {
  const [id, setId] = React.useState('');
  const [isErr, setIsErr] = React.useState(false);

  const onChange = (e) => {
    const { value } = e.target;
    setId(value);
  };

  const checkEmail = () => {
    const emailParam = { userMail: id };
    setIsErr(false);
    // 미중복이면 true
    // 중복이면 false
    checkEmailDuplication(
      emailParam,
      (v) => {
        if (v || id === '') {
          console.log('실패');
          setIsErr(true);
        } else {
          const passwordSearchParam = { email: id };
          sendResetEmail(
            passwordSearchParam,
            (e) => {
              setIsErr(true);
              alert(
                '비밀번호 재설정 링크가 입력하신 이메일로 성공적으로 전송되었습니다. '
              );
              console.log('성공');
              console.log(e);
              setIsErr(false);
            },
            () => {},
            () => {}
          );
          // 다시 로그인으로 돌아가기
          history.push({
            pathname: '/login'
          });
        }
      },
      () => {},
      () => {}
    );
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      checkEmail();
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#DDDDDD',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 100,
        paddingBottom: 100,
        height: '100vh',
      }}
    >
      <div
        style={{
          width: 510,
          height: 450,
          borderRadius: 23,
          backgroundColor: '#F9F9F9',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.1)',
        }}
      >
        <img
          alt="wizmon-logo"
          src="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-wizmon-logo-login.png"
          style={{ width: 280, height: 60, marginTop: 42 }}
        />
        <div
          style={{
            width: 337,
            height: 27,
            marginTop: 62,
            fontWeight: 600,
            fontSize: 20,
            color: '#292A2E',
          }}
        >
          비밀번호 찾기
        </div>
        <div
          style={{
            width: 337,
            height: 22,
            marginTop: 10,
            fontWeight: 'normal',
            fontSize: 16,
            color: '#848484',
          }}
        >
          회원가입시 등록한 메일 주소를 입력해 주세요.
        </div>
        <p
          style={{
            width: 337,
            height: 22,
            fontSize: 16,
            fontWeight: 400,
            color: '#FF7A00',
            marginTop: 12,
          }}
        >
          {isErr ? '이메일을 다시 확인해주세요.' : '  '}
        </p>
        <input
          placeholder="이메일 주소"
          value={id}
          name="id"
          onChange={onChange}
          type="text"
          style={{
            width: 337,
            height: 50,
            borderRadius: 25,
            paddingLeft: 20,
            paddingRight: 20,
            marginBottom: 15,
            marginTop: 8,
            border: isErr ? '1px solid #FF7A00' : '0.8px solid #CCCCCC',
          }}
          onKeyPress={handleKeyPress}
        />

        <button
          style={{
            width: 337,
            height: 54,
            borderRadius: 25,
            backgroundColor: '#B5B5B5',
            color: 'white',
            borderWidth: 0,
            marginTop: 25,
            marginBottom: 15,
            fontSize: 22,
            fontWeight: 600,
            cursor: 'pointer',
          }}
          onClick={() => {
            checkEmail();
          }}
        >
          비밀번호 찾기
        </button>
      </div>
    </div>
  );
}

export default withRouter(PwSearch);
